import React, { lazy, Suspense } from "react";
import { Card, Grid, Typography, Box } from "@material-ui/core";
import useStyles from "./styles";
import { LoadingWidget } from "Components/index";
const LoginId = lazy(() => import("./Common/LoginId"));
const Name = lazy(() => import("./Common/Name"));
const Address = lazy(() => import("./Common/Address"));
const Zipcode = lazy(() => import("./Common/Zipcode"));
const City = lazy(() => import("./Common/City"));
const Country = lazy(() => import("./Common/Country"));
const State = lazy(() => import("./Common/State"));
const Logo = lazy(() => import("./Common/Logo"));
const ContactNumber = lazy(() => import("./Common/ContactNumber"));
const SizeOfOrganization = lazy(() => import("./Common/SizeOfOrganization"));
const ReasonOfUsage = lazy(() => import("./Common/ReasonOfUsage"));
const PrimaryIndustry = lazy(() => import("./Common/PrimaryIndustry"));
const SocialMediaLink = lazy(() => import("./Common/SocialMediaLink"));
const OtherReasonOfUsage = lazy(() => import("./Common/OtherReasonOfUsage"));

const Information = () => {
  const classes = useStyles();

  return (
    <Card className={classes.companySettingForm}>
      <Typography variant="h4" className="font-20 font-semibold">
        Organization information
      </Typography>
      <Suspense
        fallback={
          <div style={{ textAlign: "center", padding: "5rem" }}>
            <LoadingWidget color="grey" pageLoader={true} />
          </div>
        }
      >
      <Box mt={3}>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6}>
            <Name />
          </Grid>
          <Grid item xs={12} sm={6} className={classes.roleField}>
            <LoginId />
          </Grid>
          <Grid item xs={12} sm={6}>
            <Address />
          </Grid>
          <Grid item xs={12} sm={6}>
            <Country />
          </Grid>
          <Grid item xs={12} sm={6}>
            <State />
          </Grid>
          <Grid item xs={12} sm={6}>
            <Grid container spacing={2} className={classes.resetSpacing}>
              <Grid item xs={12} sm={6}>
                <City />
              </Grid>
              <Grid item xs={12} sm={6}>
                <Zipcode />
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Grid container spacing={3} className={classes.removeCustomSpacing}>
              <Grid item xs={12}>
                <ContactNumber />
              </Grid>
              <Grid container spacing={3} className={classes.resetSpacingLogo}>
                <Grid item xs={12}>
                  <Typography variant="body2" className="font-semibold">
                    Logo{" "}
                    <span className="f-gray font-12 font-regular">
                      (Transparent background and white text recommended)
                    </span>
                  </Typography>
                </Grid>
              </Grid>
              <Grid item xs={12}>
                <Logo />
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Grid container spacing={3} className={classes.removeCustomSpacing}>
              <Grid item xs={12}>
                <ReasonOfUsage />
              </Grid>
              <Grid item xs={12} className={classes.textArea}>
                <OtherReasonOfUsage />
              </Grid>
              <Grid item xs={12} className={classes.formGroup}>
                <PrimaryIndustry />
                <SizeOfOrganization />
              </Grid>
            </Grid>
          </Grid>
          <SocialMediaLink />
        </Grid>
      </Box>
      </Suspense>
    </Card>
  );
};

export default Information;
